var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useRef } from 'react';
import { useMemo } from 'react';
import { useDetectOutsideClick } from '../../../detect-outside-click';
import { NavigationContext } from '../../provider';
import { NavigationActionSheetContainer, NavigationActionSheetInnerContainer, } from './styles/navigation-action-sheet.styled';
/**
 * The action sheet is a container for the action content.
 * It is used to display the content of the action when the action is active in a sheet that is shown as a sort of modal.
 */
export const NavigationActionSheet = (_a) => {
    var { children, reference, dataTest = 'navigation-action-sheet' } = _a, props = __rest(_a, ["children", "reference", "dataTest"]);
    const { activeActionReference, setActiveActionReference, navigationViewportBreakpoint } = useContext(NavigationContext);
    const ref = useRef(null);
    const isMobileViewports = useMemo(() => ['xxs', 'xs', 'sm', 'md'].includes(navigationViewportBreakpoint), [navigationViewportBreakpoint]);
    useDetectOutsideClick({
        ref,
        onClickOutside: () => {
            if (activeActionReference === reference) {
                if (isMobileViewports && activeActionReference === 'login')
                    return;
                setActiveActionReference(null);
            }
        },
    });
    return (_jsx(NavigationActionSheetContainer, Object.assign({ "$isActive": activeActionReference === reference, "data-test": dataTest }, props, { children: _jsx(NavigationActionSheetInnerContainer, { ref: ref, children: children }) })));
};
